import { decodeText, encodeText } from '@aytm/app/stats/lib/util/helpers'
import { measureTextWidth } from '@aytm/app/stats/lib/util/dom'
import {
  removeLogicFromText as _removeLogicFromText,
  removeScriptsFromText as _removeScriptsFromText,
  removeTagsFromText as _removeTagsFromText
} from '@aytm/app/stats/page/components/lib/utils'

export const truncateText = (text, limit = 30) => {
  let result = decodeText(removeTagsFromText(text))
  result = limit < result.length ? result.slice(0, limit - 3) + '...' : result
  return encodeText(result)
}

export const removeLogicFromText = text => {
  return _removeLogicFromText(text)
}

export const removeLogicAndTruncate = (text, limit = 30) => {
  const result = truncateText(removeLogicFromText(text), limit)
  return result.replace(/&lbrack;/g, '[').replace(/&rbrack;/g, ']')
}

export const removeScriptsFromText = text => _removeScriptsFromText(text)

// Chart labels are handed on as markup, so this family drops script elements as well as formatting.
export const removeTagsFromText = text => _removeTagsFromText(text, { removeScripts: true })

export const noTextPlaceholder = (el, label = '', position = '') => {
  if (!Object.hasOwn(el, 'image') && !/^\[asset.*im_/i.test(el.text)) return ''
  return (label || (Object.hasOwn(el, 'answerVariants') ? 'B' : 'A')) + (position || el.position)
}

const LABEL_FONT = '12px Ubuntu, Calibri, Segoe, Helvetica, Arial'

// Cut a label to the width of `l` digits in the chart font. Measured on a canvas, so no label lays the
// report out: in-page measuring cost a full layout per character.
export const transformText = (rawText, l = 40) => {
  const text = decodeText(removeTagsFromText(removeLogicFromText(rawText)))

  const limit = measureTextWidth('1'.repeat(parseInt(l, 10)), LABEL_FONT)
  if (null === limit) return encodeText(text, false)

  // measured as the page lays text out: whitespace runs count once and none counts at either end, in
  // whole pixels, so the cut lands on the same character as it does on the page
  const laidOut = index => text.slice(0, index).replace(/\s+/g, ' ').trim()
  const fits = index => Math.round(measureTextWidth(laidOut(index), LABEL_FONT)) <= Math.round(limit)

  let index = 0
  while (index < text.length && fits(index)) index++

  return encodeText(index < text.length ? text.slice(0, index - 3) + '...' : text, false)
}
